import ContactForm from "./contact-form.component";

function ContactModal({ openModel }: { openModel: () => void }) {
  return (
    <>
      {/* Open the modal using document.getElementById('ID').showModal() method */}
      <span
        role="button"
        onClick={openModel}>
        Contact Us
      </span>
    </>
  );
}

export const ContactContent = ({
  isContactOpen,
  closeModel,
}: {
  isContactOpen: boolean;
  closeModel: () => void;
}) => {
  return (
    <>
      <dialog
        id="my_modal_5"
        className="modal bg-white/40 dark:bg-black/40 backdrop-blur-sm"
        open={isContactOpen}>
        <div className="modal-box w-11/12 max-w-5xl bg-white dark:bg-casagray-900">
          <form method="dialog">
            {/* if there is a button in form, it will close the modal */}
            <button
              className="btn z-10 btn-square btn-outline absolute right-6 top-6"
              onClick={closeModel}>
              ✕
            </button>
          </form>
          <section className="relative lg:p-10">
            <div className="mx-auto max-w-2xl py-16 text-center">
              <h1 className="text-center font-bold mb-8 text-3xl sm:text-4xl text-casagray-950 dark:text-white lg:text-5xl">
                <span>
                  Get in <span className="text-orange-600">Touch</span>
                </span>
              </h1>
              <p className="text-lg text-center leading-normal">
                Share your thoughts, and we'll respond promptly.
              </p>
            </div>
            <ContactForm />
          </section>
        </div>
      </dialog>
    </>
  );
};

export default ContactModal;
